import { FilesetResolver, FaceLandmarker } from '@mediapipe/tasks-vision';

export const getScoreClassName = (score) => {
  if (score <= 4) {
    return 'red';
  }
  if (score <= 7) {
    return 'yellow';
  }
  return 'green';
};

export const getScoreKey = (score) => {
  if (score < 4) {
    return 'canBeImproved';
  }
  if (score < 7) {
    return 'moderate';
  }
  if (score < 9) {
    return 'isGood';
  }
  return 'isExcellent';
};

// const model = faceLandmarksDetection.SupportedModels.MediaPipeFaceMesh;
// const detectorConfig = {
//   runtime: 'mediapipe',
//   solutionPath: 'https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh',
// };

// export const detectorPromise = faceLandmarksDetection.createDetector(model, detectorConfig);

export const detectorPromise = FilesetResolver.forVisionTasks('https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@latest/wasm').then(
  (filesetResolver) =>
    FaceLandmarker.createFromOptions(filesetResolver, {
      baseOptions: {
        modelAssetPath: 'https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task',
        delegate: 'CPU',
      },
      numFaces: 1,
      runningMode: 'IMAGE',
    }),
);
